import { createBrowserRouter } from 'react-router-dom';

import { AppLayout } from '@/layouts/AppLayout';
import { PublicLayout } from '@/layouts/PublicLayout';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';
import { CatalogPage } from '@/pages/CatalogPage';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { ModuleDetailPage } from '@/pages/ModuleDetailPage';
import { ForbiddenPage, NotFoundPage } from '@/pages/NotFoundPage';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { TrackDetailPage } from '@/pages/TrackDetailPage';
import { AdminPage } from '@/pages/app/AdminPage';
import { CourseReaderPage } from '@/pages/app/CourseReaderPage';
import { DashboardPage } from '@/pages/app/DashboardPage';
import { InstructorPage, LabSolutionPage } from '@/pages/app/InstructorPage';
import { LabPage } from '@/pages/app/LabPage';
import { MyCoursesPage } from '@/pages/app/MyCoursesPage';
import { QuizPage } from '@/pages/app/QuizPage';
import { ResourcesPage } from '@/pages/app/ResourcesPage';

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/parcours', element: <CatalogPage /> },
      { path: '/parcours/:slug', element: <TrackDetailPage /> },
      { path: '/modules/:identifier', element: <ModuleDetailPage /> },
      { path: '/projets', element: <ProjectsPage /> },
      { path: '/acces-refuse', element: <ForbiddenPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '/connexion', element: <LoginPage /> },
  {
    // Every route below also has its authorisation enforced by the API.
    element: <ProtectedRoute />,
    children: [
      {
        path: '/app',
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'formations', element: <MyCoursesPage /> },
          { path: 'ressources', element: <ResourcesPage /> },
          { path: 'modules/:moduleCode/chapitres/:chapterSlug', element: <CourseReaderPage /> },
          { path: 'tp/:labId', element: <LabPage /> },
          { path: 'quiz/:quizId', element: <QuizPage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute roles={['instructor', 'admin']} />,
    children: [
      {
        path: '/app/formateur',
        element: <AppLayout />,
        children: [
          { index: true, element: <InstructorPage /> },
          { path: 'tp/:labId', element: <LabSolutionPage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute roles={['admin']} />,
    children: [
      {
        path: '/app/administration',
        element: <AppLayout />,
        children: [{ index: true, element: <AdminPage /> }],
      },
    ],
  },
]);
